/**
 * DuplicateAlertsBadge — kleines Zähler-Badge, das die Anzahl offener Dedup-
 * Warnungen anzeigt und beim Klick den Alert-Panel öffnet.
 *
 * UX-Prinzipien (angelehnt an HubSpot / Salesforce / Pipedrive):
 *   - Standard-Zustand: unsichtbar solange keine Alerts existieren
 *     (kein permanenter Rauschsymbol im UI).
 *   - Zähler zeigt die exakte Zahl bis 99, ab 100 nur noch "99+".
 *   - Klick öffnet das Panel; kein Auto-Popup — der User entscheidet.
 *
 * Styles liegen in DuplicateAlertsPanel.css (Apple × BonusClub).
 */

import React, { useState } from 'react';
import useDuplicateAlerts from './useDuplicateAlerts';
import DuplicateAlertsPanel from './DuplicateAlertsPanel';
import './DuplicateAlertsPanel.css';

export default function DuplicateAlertsBadge({ userId, onOpenAlert }) {
  const [isPanelOpen, setPanelOpen] = useState(false);
  const { openCount, loading } = useDuplicateAlerts(userId);

  if (loading || openCount === 0) return null;

  const label = openCount > 99 ? '99+' : String(openCount);
  const isSingular = openCount === 1;

  return (
    <>
      <button
        type="button"
        className="duplicate-alerts-badge"
        onClick={() => setPanelOpen(true)}
        title={`${openCount} open duplicate warning${isSingular ? '' : 's'} — click to review`}
      >
        <span className="duplicate-alerts-badge__count">{label}</span>
        <span>
          {isSingular ? 'Duplicate' : 'Duplicates'}
        </span>
      </button>

      {isPanelOpen && (
        <DuplicateAlertsPanel
          userId={userId}
          onClose={() => setPanelOpen(false)}
          onOpenAlert={onOpenAlert}
        />
      )}
    </>
  );
}
